module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1248
// module chunks = 3